import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 14v-6h-6","key":"svg-0"}],["path",{"d":"M21 8l-9 9l-9 -9","key":"svg-1"}]]

const IconArrowElbowRight = createReactComponent('outline', 'arrow-elbow-right', 'ArrowElbowRight', __iconNode);

export default IconArrowElbowRight;